import React from "react";
import { getLocalStorageValue } from "config/helper";

const ComponentToPrintTheme2 = React.forwardRef((props, ref) => {
  const barcodeImage = getLocalStorageValue("user-barcode");
  const { member_number } = props;
  
  return (
    <>
      <div ref={ref}>
        <div style={{ textAlign: "center", padding: "20px" }}>
          <img
            alt="Barcode"
            src={barcodeImage ? barcodeImage : ""}
            style={{ marginBottom: "0px" }}
          />
          {member_number ? <div style={{ fontSize: "18px", fontWeight: "bold" }}>
            Member Number: {member_number}
          </div> : null}
        </div>
      </div>
    </>
  );
});
export default ComponentToPrintTheme2;
